import { Link } from "react-router-dom";
import { useFocusManagement } from "../hooks/useAccessibility";
import NavItem from "./NavItem";

function MobileMenu({ isOpen, onClose, groups, dashboardLink, user }) {
  const containerRef = useFocusManagement(isOpen);

  if (!isOpen) return null;

  const initials = (user?.first_name || user?.username || "U")
    .charAt(0)
    .toUpperCase();

  return (
    <div
      ref={containerRef}
      className="lg:hidden absolute top-full left-0 right-0 bg-card-bg border-t border-card-border shadow-lg z-50"
      role="dialog"
      aria-modal="true"
      aria-label="Mobile navigation menu"
    >
      <div className="px-4 py-4 space-y-1">
        {user && (
          <div className="flex items-center gap-3 px-4 py-3 mb-2 bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20 rounded-xl border border-emerald-100 dark:border-emerald-800/30">
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white font-semibold">{initials}</span>
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-text-primary truncate">
                {user.first_name || user.username}
              </p>
              <p className="text-xs text-text-secondary truncate">{user.email}</p>
            </div>
          </div>
        )}

        {dashboardLink && (
          <NavItem
            path={dashboardLink.path}
            label={dashboardLink.label}
            onClick={onClose}
          />
        )}

        {groups.map((group) => (
          <div key={group.id}>
            <p className="px-4 pt-3 pb-1 text-xs font-semibold text-text-tertiary uppercase tracking-wider">
              {group.label}
            </p>
            {group.items.map((item) => (
              <NavItem
                key={item.path}
                path={item.path}
                label={item.label}
                onClick={onClose}
              />
            ))}
          </div>
        ))}

        {!user && (
          <div className="pt-2 border-t border-card-border space-y-1">
            <Link
              to="/login"
              onClick={onClose}
              className="block px-4 py-2 text-sm text-text-primary hover:bg-bg-secondary rounded-lg transition-colors"
            >
              Sign In
            </Link>
            <Link
              to="/register"
              onClick={onClose}
              className="block px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-emerald-600 to-teal-600 rounded-lg"
            >
              Get Started
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default MobileMenu;
